import { useContext } from 'react';
import { EmployeesContext } from '../context/EmployeesContextObject';
import { EmployeesContextType } from '../types';

export const useEmployees = (): EmployeesContextType => {
  const context = useContext(EmployeesContext);
  if (context === undefined) {
    throw new Error('useEmployees must be used within a EmployeesDataProvider');
  }
  return context;
};
